<template>
  <!-- 课程页 -->
  <div class="Homes">
    <div
      class="Materiaupload"
      v-if="this.$store.state.user.status === '已通过'"
    >
      <div class="altk" @click="uploadmaterial()">
        <i class="iconfont gos-shangchuan1"></i>
      </div>
      <span @click="uploadmaterial()"> 课程上传</span>
    </div>
    <div div class="total-heat">
      <div class="total-concte">
        <div class="top">
          <div class="top-Major">
            <p>专业大类:</p>
            <el-radio-group @change="selitemis()" v-model="radio1" size="mini">
              <el-radio-button label="全部"></el-radio-button>
              <el-radio-button
                v-for="item in Majorcategories"
                :key="item.id"
                :label="item.name"
              ></el-radio-button>
            </el-radio-group>
          </div>
          <div class="top-Major">
            <p>是否付费:</p>
            <el-radio-group @change="selitemis()" v-model="radio2" size="mini">
              <el-radio-button label="全部"></el-radio-button>
              <el-radio-button label="免费"></el-radio-button>
              <el-radio-button label="付费"></el-radio-button>
              <!-- <el-radio-button label="试看"></el-radio-button> -->
            </el-radio-group>
          </div>
          <!-- <div class="top-Major">
            <p>播放方式:</p>
            <el-radio-group v-model="radio3" size="mini">
              <el-radio-button label="全部"></el-radio-button>
              <el-radio-button label="录播"></el-radio-button>
              <el-radio-button label="直播"></el-radio-button>
            </el-radio-group>
          </div> -->
          <div class="top-Major">
            <p>排序方式:</p>
            <el-radio-group v-model="radio4" size="mini">
              <el-radio-button
                @click.native="payAllotChange($event, 9)"
                label="默认"
              >
              </el-radio-button>
              <el-radio-button
                @click.native="payAllotChange($event, 1)"
                label="最新"
                >最新
                <img
                  class="ingmssj"
                  src="../../assets/thetriangle.png"
                  alt=""
                />
                <img
                  class="ingmssj"
                  v-if="zx && radio4 === '最新'"
                  src="../../assets/thetriangle1.png"
                  alt=""
                />
                <img class="ingmssj1" src="../../assets/sjs.png" alt="" />
                <img
                  class="ingmssj1"
                  v-if="zxx && radio4 === '最新'"
                  src="../../assets/Thetriangle2.png"
                  alt=""
                />
              </el-radio-button>
              <el-radio-button
                @click.native="payAllotChange($event, 2)"
                label="收藏"
              >
                收藏
                <img
                  class="ingmssj"
                  src="../../assets/thetriangle.png"
                  alt=""
                />
                <img
                  class="ingmssj"
                  v-if="sc && radio4 === '收藏'"
                  src="../../assets/thetriangle1.png"
                  alt=""
                />
                <img class="ingmssj1" src="../../assets/sjs.png" alt="" />
                <img
                  class="ingmssj1"
                  v-if="scc && radio4 === '收藏'"
                  src="../../assets/Thetriangle2.png"
                  alt=""
                />
              </el-radio-button>

              <el-radio-button
                label="浏览"
                @click.native="payAllotChange($event, 3)"
              >
                浏览
                <img
                  class="ingmssj"
                  src="../../assets/thetriangle.png"
                  alt=""
                />
                <img
                  class="ingmssj"
                  v-if="ll && radio4 === '浏览'"
                  src="../../assets/thetriangle1.png"
                  alt=""
                />
                <img class="ingmssj1" src="../../assets/sjs.png" alt="" />
                <img
                  class="ingmssj1"
                  v-if="lll && radio4 === '浏览'"
                  src="../../assets/Thetriangle2.png"
                  alt=""
                />
              </el-radio-button>
              <el-radio-button
                label="评分"
                @click.native="payAllotChange($event, 4)"
                >评分
                <img
                  class="ingmssj"
                  src="../../assets/thetriangle.png"
                  alt=""
                />
                <img
                  class="ingmssj"
                  v-if="pfjts && radio4 === '评分'"
                  src="../../assets/thetriangle1.png"
                  alt=""
                />
                <img class="ingmssj1" src="../../assets/sjs.png" alt="" />
                <img
                  class="ingmssj1"
                  v-if="pfjtx && radio4 === '评分'"
                  src="../../assets/Thetriangle2.png"
                  alt=""
                />
              </el-radio-button>
              <!-- <el-radio-button label="预约"></el-radio-button> -->
            </el-radio-group>
          </div>
        </div>
        <div class="buttom">
          <ul class="Course" style="min-height: 500px">
            <li class="Live1" v-for="(iten, index) in tableData" :key="index">
              <video
                :poster="$store.state.https + iten.tp"
                class="videois"
                @click="jump(iten)"
                :src="htto + iten.sp"
              ></video>
              <div class="thevideo">
                <div class="theh4" @click="jump(iten)">
                  {{ iten.name }}
                </div>

                <p class="wb" @click="jump(iten)" v-html="iten.kcjs"></p>
                <div class="jejq">
                  <span class="je">{{ iten.jg }}</span>
                  <div v-if="radio4 === '浏览' || radio4 === '默认'">
                    <i
                      style="font-size: 14px; color: #999999; line-height: 20px"
                      class="iconfont gos-yanjing1"
                    ></i>
                    <p class="dzs">浏览量：{{ iten.ll }}</p>
                  </div>
                  <div v-if="radio4 === '收藏'">
                    <i
                      style="font-size: 14px; color: #999999; line-height: 20px"
                      class="iconfont gos-aixin"
                    ></i>
                    <p class="dzs">收藏：{{ iten.sc }}</p>
                  </div>
                  <div v-if="radio4 === '最新' || radio4 === '最新倒'">
                    <p class="dzs">{{ iten.scrq }}</p>
                  </div>
                  <div v-if="radio4 === '评分'">
                    <el-rate disabled v-model.number="iten.pf"></el-rate>
                  </div>
                </div>
                <div class="collection">
                  <span class="dzs" @click="eacherpage(iten.userid)"
                    ><img class="imgssz" :src="htto + iten.lstx" alt="" />{{
                      iten.lsxm
                    }}</span
                  >
                  <button
                    v-if="iten.jg !== '免费'"
                    @click="jump(iten)"
                    class="Buynow"
                  >
                    立即购买
                  </button>
                  <button
                    v-if="iten.jg == '免费'"
                    @click="jump(iten)"
                    class="Buynow"
                  >
                    立即查看
                  </button>
                </div>
              </div>
            </li>
          </ul>
          <el-pagination
            v-if="this.paging.total !== 0"
            @current-change="handleCurrentChange"
            :page-size="paging.rows"
            background
            prev-text="上一页"
            next-text="下一页"
            layout="prev, pager, next"
            :total="paging.total"
            :pager-count="5"
          >
          </el-pagination>

          <h4
            align="left"
            v-if="this.$store.state.isLogin && Guess.length !== 0"
            class="Guessyoulike"
          >
            猜你喜欢
          </h4>
          <ul
            class="Course"
            v-if="this.$store.state.isLogin && Guess.length !== 0"
          >
            <li class="Live1" v-for="(iten, index) in Guess" :key="index">
              <video
                class="videois"
                @click="jump(iten)"
                :src="htto + iten.sp"
              ></video>
              <div class="thevideo">
                <h4 @click="jump(iten)">{{ iten.name }}</h4>
                <p class="wb" @click="jump(iten)" v-html="iten.kcjs"></p>
                <div class="jejq">
                  <span class="je">{{ iten.jg }}</span>
                  <div>
                    <i
                      style="font-size: 14px; color: #999999; line-height: 20px"
                      class="iconfont gos-yanjing1"
                    ></i>
                    <p class="dzs">浏览量：{{ iten.ll }}</p>
                  </div>
                </div>
                <div class="collection">
                  <span class="dzs" @click="eacherpage(iten.userid)"
                    ><img class="imgssz" :src="htto + iten.lstx" alt="" />{{
                      iten.lsxm
                    }}</span
                  >
                  <button
                    v-if="iten.jg !== '免费'"
                    @click="jump(iten)"
                    class="Buynow"
                  >
                    立即购买
                  </button>
                  <button
                    v-if="iten.jg == '免费'"
                    @click="jump(iten)"
                    class="Buynow"
                  >
                    立即查看
                  </button>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { selitem, selsort, selitemcnxx } from "../../api/patient";
import Bus from "@/utils/bus";

export default {
  data() {
    return {
      pfjts: false,
      pfjtx: false,
      ll: false,
      lll: false,
      sc: false,
      scc: false,
      zx: false,
      zxx: false,
      Guess: [],
      Majorcategories: "",
      htto: this.$store.state.https,
      tableData: {},
      paging: {
        page: 1,
        rows: 12,
        total: 50,
      },
      radio1: "全部",
      radio2: "全部",
      radio3: "全部",
      radio4: "默认",
      zixinss: false,
      zixinsc: false,
      zixinll: false,
      zixinpf: false,
      saa: 0,
    };
  },
  async created() {
    await this.selitemis();
    await this.selsortis();
    await this.selitemcnxxis();
  },
  mounted() {
    Bus.$emit("activeRouter", "/myinformation");
  },
  methods: {
    uploadmaterial() {
      if (this.$store.state.isLogin) {
        this.$router.push("/Courseupload");
      } else {
        this.$message({
          showClose: true,
          message: "请先进行登录",
          type: "warning",
        });
      }
    },
    // 最新/
    async payAllotChange(el, val) {
      if (el.target.tagName === "STRONG" || el.target.tagName === "INPUT")
        return;
      if (val === 9) {
        this.zixinss = false;
        this.zixinsc = false;
        this.zixinll = false;
        this.zixinpf = false;
      }
      if (val === 1) {
        this.zixinsc = false;
        this.zixinll = false;
        this.zixinpf = false;
        if (this.zixinss) {
          this.zx = false;
          this.zxx = true;
          this.zzxsjs();
          this.selitemis();
          this.zixinss = false;
        } else {
          this.zzxsj();
          this.zxx = false;
          this.zx = true;
          // this.ynxgss('最新')
          this.selitemis();
          this.zixinss = true;
        }
      }
      if (val === 2) {
        this.zixinll = false;
        this.zixinss = false;
        this.zixinpf = false;
        if (this.zixinsc) {
          this.sc = false;
          this.scc = true;
          this.collectionis();
          this.selitemis();
          this.zixinsc = !this.zixinsc;
        } else {
          this.sc = true;
          this.scc = false;
          this.collectioni();
          this.selitemis();
          this.zixinsc = !this.zixinsc;
        }
      }
      if (val === 3) {
        this.zixinsc = false;
        this.zixinss = false;
        this.zixinpf = false;
        if (this.zixinll) {
          this.ll = false;
          this.lll = true;
          this.llis();
          this.selitemis();
          this.zixinll = !this.zixinll;
        } else {
          this.ll = true;
          this.lll = false;
          this.lliss();
          this.selitemis();
          this.zixinll = !this.zixinll;
        }
      }
      if (val === 4) {
        this.zixinsc = false;
        this.zixinss = false;
        this.zixinll = false;
        if (this.zixinpf) {
          this.pfjtx = true;
          this.pfjts = false;

          this.pfidx();
          this.selitemis();
          this.zixinpf = !this.zixinpf;
        } else {
          this.pfjts = true;
          this.pfjtx = false;
          this.pfids();
          this.selitemis();
          this.zixinpf = !this.zixinpf;
        }
      }
    },
    // 课程列表
    async selitemis() {
      var data = new FormData();
      data.append("page", this.paging.page);
      data.append("rows", this.paging.rows);
      data.append("status", "已发布");
      if (this.radio1 !== "全部") {
        data.append("sort", this.radio1);
      }
      if (this.radio2 !== "全部") {
        data.append("jg", this.radio2);
      }
      if (this.sc === true) {
        data.append("px", "收藏倒");
      }
      if (this.scc === true) {
        data.append("px", "收藏");
      }
      if (this.zx === true) {
        data.append("px", "最新");
      }
      if (this.zxx === true) {
        data.append("px", "最新倒");
      }
      if (this.lll === true) {
        data.append("px", "浏览");
      }
      if (this.ll === true) {
        data.append("px", "浏览倒");
      }
      if (this.pfjtx === true) {
        data.append("px", "评分");
      }
      if (this.pfjts === true) {
        data.append("px", "评分倒");
      }
      var res = await selitem(data);
      this.tableData = res.rows;
      this.paging.total = res.total;
      for (let i = 0; i < this.tableData.length; i++) {
        this.tableData[i].pf = Number(this.tableData[i].pf);
      }

      // this.radio4 = '默认'
    },
    // 评分
    pfidx() {
      this.ll = false;
      this.lll = false;
      this.sc = false;
      this.scc = false;
      this.zx = false;
      this.zxx = false;
    },
    pfids() {
      this.ll = false;
      this.lll = false;
      this.sc = false;
      this.scc = false;
      this.zx = false;
      this.zxx = false;
    },
    // 浏览倒
    llis() {
      this.pfjts = false;
      this.pfjtx = false;

      this.sc = false;
      this.scc = false;
      this.zx = false;
      this.zxx = false;
    },
    // 浏览
    lliss() {
      this.pfjts = false;
      this.pfjtx = false;

      this.sc = false;
      this.scc = false;
      this.zx = false;
      this.zxx = false;
    },
    // 收藏倒
    collectionis() {
      this.pfjts = false;
      this.pfjtx = false;
      this.ll = false;
      this.lll = false;

      this.zx = false;
      this.zxx = false;
    },
    // 收藏
    collectioni() {
      this.pfjts = false;
      this.pfjtx = false;
      this.ll = false;
      this.lll = false;

      this.zx = false;
      this.zxx = false;
    },
    // 最新
    async zzxsj() {
      this.pfjts = false;
      this.pfjtx = false;
      this.ll = false;
      this.lll = false;
      this.sc = false;
      this.scc = false;
    },
    async zzxsjs() {
      this.pfjts = false;
      this.pfjtx = false;
      this.ll = false;
      this.lll = false;
      this.sc = false;
      this.scc = false;
    },
    async ynxgss(item) {
      var data = new FormData();
      data.append("page", this.paging.page);
      data.append("rows", this.paging.rows);
      data.append("status", "已发布");
      if (this.radio1 !== "全部") {
        data.append("sort", this.radio1);
      }
      if (this.radio2 !== "全部") {
        data.append("jg", this.radio2);
      }
      data.append("px", item);
      var res = await selitem(data);
      this.tableData = res.rows;
      this.paging.total = res.total;
      for (let i = 0; i < this.tableData.length; i++) {
        this.tableData[i].pf = Number(this.tableData[i].pf);
      }
    },
    // 猜你喜欢
    selitemcnxxis() {
      if (this.$store.state.isLogin) {
        var data = new FormData();
        data.append("userid", this.$store.state.user.id);
        selitemcnxx(data).then((res) => {
          console.log(res);
          for (let s = 0; s < res.length; s++) {
            if (res[s] !== null) {
              this.Guess.push(res[s]);
            }
          }
          console.log(this.Guess);
        });
      }
    },
    // 筛选出类
    async selsortis() {
      var data = new FormData();
      data.append("page", 1);
      data.append("rows", 100);
      await selsort(data).then((res) => {
        this.Majorcategories = res.rows;
      });
    },
    // 跳转老师页面
    eacherpage(item) {
      this.$router.push(`/TeacherDetailsPage/${item}`);
    },
    plays() {
      this.$refs.videoPlay.play();
    },
    pauses() {
      // this.$refs.videoPlay.pause()
    },
    // /跳转
    jump(item) {
      this.$router.push("/coursedetailspage");
      this.$store.commit("Jumpfordetails", item.id);
      window.scrollTo({
        top: 1,
      });
    },

    handleSelect(key, keyPath) {},
    handleCurrentChange(val) {
      this.paging.page = val;
      this.selitemis();
    },
  },
};
</script>
<style scoped lang="scss">
.Homes {
  box-shadow: 0px 0px 3px 4px rgba(6, 0, 1, 0.07);
  padding-top: 4px;
  margin-top: 4px;
  background: #fff;
  width: 100%;
  min-height: 100%;

  .total-heat {
    width: 1190px;
    margin: auto;
    background: #fff;
    .total-concte {
      margin-left: 50px;
      margin-right: 50px;
      padding-bottom: 50px;

      .top {
        .top-Major {
          padding-top: 16px;
          padding-bottom: 15px;
          width: 100%;
          // height: 60px;
          line-height: 30px;
          display: flex;
          text-align: left;
          border-bottom: 1px solid #f3f3f3;
          p {
            height: 30px;
            font-size: 14px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #999999;
            margin-right: 21px;
          }
          .el-radio-group {
            min-height: 100%;
            .el-radio-button {
              ::v-deep .el-radio-button__inner {
                width: 79px;
                padding: 0px;
                text-align: center;
                height: 30px;
                font-size: 14px;
                font-family: Source Han Sans CN;
                font-weight: 400;
                color: #333333;
                border: 0px solid;
                line-height: 30px;
                border-radius: 14px;
              }
              ::v-deep
                .el-radio-button__orig-radio:checked
                + .el-radio-button__inner {
                width: 79px;
                height: 30px;
                border-radius: 14px;
                background: #4ccaff;

                color: #fff;
                box-shadow: -1px 0 0 0 #4ccaff;
              }
            }
          }
        }
      }
      .buttom {
        margin-top: 27px;
        .Course {
          display: flex;
          width: 100%;

          justify-content: left;
          flex-wrap: wrap;
          .Live1 {
            width: 247px;
            height: 299px;
            background: #ffffff;
            border: 1px solid #f6f6f6;
            border-radius: 6px;
            margin-bottom: 20px;
            transition: all 0.2s;
            margin-left: 17px;
            .thevideo {
              display: flex;
              flex-direction: column;
              padding: 10px 20px;
              .theh4 {
                overflow-x: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                font-size: 15px;
                width: 220px;
                text-align: left;
              }
              .wb {
                display: flex;
                text-align: left;
                margin-top: 10px;
                width: 203px;
                height: 38px;
                cursor: pointer;
                font-size: 12px;
                font-family: Source Han Sans CN;
                font-weight: 400;
                color: #999999;
                line-height: 19px;
                display: -webkit-box; /**对象作为伸缩盒子模型展示**/
                -webkit-box-orient: vertical; /**设置或检索伸缩盒子对象的子元素的排列方式**/
                -webkit-line-clamp: 2; /**显示的行数**/
                overflow: hidden; /**隐藏超出的内容**/
              }
              .jejq {
                margin-top: 3px;
                display: flex;
                justify-content: space-between;
                .je {
                  // width: 66px;
                  font-size: 14px;
                  font-family: Source Han Sans CN;
                  font-weight: bold;
                  color: #ff1616;
                }
                div {
                  display: flex;
                  img {
                    width: 12px;
                    height: 12px;
                    line-height: 12px;
                    margin-right: 8px;
                    padding-top: 2px;
                  }
                  .dzs {
                    font-size: 12px;
                    margin-left: 5px;
                    font-family: Source Han Sans CN;
                    font-weight: 400;
                    color: #999999;
                  }
                }
              }
              .collection {
                padding-top: 8px;
                margin-top: 5px;
                display: flex;
                justify-content: space-between;
                border-top: 2px solid #f6f6f6;
                .dzs {
                  cursor: pointer;
                  white-space: nowrap;
                  height: 13px;
                  font-size: 12px;
                  font-family: Source Han Sans CN;
                  font-weight: 400;
                  color: #999999;
                }
                .Buynow {
                  cursor: pointer;
                  white-space: nowrap;
                  // display: flex;
                  text-align: center;
                  width: 67px;
                  height: 23px;
                  background: #4ccaff;
                  border-radius: 4px;
                  border: 1px;
                  font-size: 12px;
                  font-family: Source Han Sans CN;
                  font-weight: 400;
                  color: #ffffff;
                }
                .Buynow:hover {
                  background: #4ccaffc9;
                }
              }
            }
          }
          .Live1:hover {
            transform: translateY(-2px);
            box-shadow: 0 12px 20px 0 rgba(95, 101, 105, 0.15);
          }
        }
        .el-pagination {
          margin-top: 60px;
          margin-bottom: 30px;
        }
      }
    }
  }
}
.Guessyoulike {
  font-size: 22px;
  font-family: Source Han Sans CN;
  font-weight: bold;
  color: #333333;
  margin: 0;
  margin-bottom: 22px;
}
.videois {
  width: 247px;
  height: 151px;
  border-radius: 6px 6px 0px 0px;
  object-fit: contain;
}
.imgssz {
  cursor: pointer;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  margin-right: 10px;
}
.ingmssj {
  position: absolute;
  right: 11px;
  top: 7.5px;
  width: 10px;
  height: 8px;
}
.ingmssj1 {
  position: absolute;
  right: 11px;
  top: 15px;
  width: 10px;
  height: 8px;
}
.el-pagination {
  ::v-deep span {
    padding: 0 10px;
  }
}
.Materiaupload {
  position: fixed;
  top: 15.6rem;
  right: 11.2rem;
  span {
    font-size: 12px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #4ccaff;
  }
}
.altk {
  width: 48px;
  height: 48px;
  background: #4ccaff;
  border-radius: 6px;
  text-align: center;
  line-height: 48px;
  margin-bottom: 8px;
  .iconfont {
    font-size: 28px;
    color: #fff;
  }
}
// 适配手机端
@media (max-width: 768px) {
  .Homes {
    width: 100vw;
    .total-heat {
      width: 95vw;
      .total-concte {
        margin-left: 0px;
        margin-right: 0px;
        .top {
          .top-Major {
            width: 95vw;
            flex-shrink: 0; /* 防止项目在空间不足时缩小 */
            white-space: nowrap; /* 确保项目不换行 */
            /* 样式调整，根据需要设置宽度、间距等 */
            margin-right: 10px;
            /* 其他样式 */
            overflow-x: auto;
          }
        }
        .buttom {
          .Course {
            width: 98vw;
            margin: auto;
            .Live1 {
              width: 45vw;
              height: 245px;
              margin-left: 5px;
              margin-right: 5px;
              .thevideo {
                padding: 5px;
                .theh4 {
                  width: 160px;
                }
                .wb {
                  width: 160px;
                }
              }
            }
          }
          .el-pagination {
            width: 95vw;
            text-align: left;
          }
        }
      }
    }
  }
  .videois {
    width: 44vw;
    height: 97px;
  }
  .el-pagination {
    ::v-deep span {
      padding: 0 5px;
    }
  }
  .Materiaupload {
    position: fixed;
    top: 18rem;
    right: 1rem;
    z-index: 1;
  }
}
</style>
